import { useLocation } from 'react-router-dom'
import { usePageTitle } from '../hooks/usePageTitle'
import { getPageTitleForPath } from '../utils/pageTitles'

/** Syncs browser tab title with the current route. */
export default function DocumentTitle() {
  const { pathname } = useLocation()
  usePageTitle(getPageTitleForPath(pathname))
  return null
}
